import React from "react";
import styled from "styled-components";
import { Controller, Scene } from "react-scrollmagic";
import { Tween } from "react-gsap";
import { css } from '@emotion/css'
import ShotChart from "../ShotChart/ShotChart";
import PopUp from "../ShotChart/PopUp";
import { colors } from "../../shared/config";

import natalie_img from "../images/natalie.png";
import natalie_name from "../images/natalie_name.png";
import charisma_img from "../images/charisma.png";
import charisma_name from "../images/charisma_name.png";
import lauryn_img from "../images/lauryn.png";
import lauryn_name from "../images/lauryn_name.png";
import michaela_img from "../images/michaela.png";
import michaela_name from "../images/michaela_name.png";
import japreece_img from "../images/japreece.png";
import japreece_name from "../images/japreece_name.png";
//import PopUp from "../components/ShotChart/PopUp";
const Section = styled.div ` 
height:24px;
padding-left: 5%;
padding-bottom: 0%;
top: 150px;

font-family: Optima;
font-style: normal;
font-weight: normal;
font-size: 20px;
line-height: 24px;
text-transform: uppercase;

color: #FFFFFF;

text-transform: uppercase;
background-color: ${colors.background};
`

const playersW = [
  {
    name: "natalie",
    nameslug: "natalie-chou",
    pct: [29.3,	53.3,	31.8,	33.3,	22.5,	58.3,	30.0,	40.0,	55.6],
    totals: [
      { made: 12, shot: 41 },
      { made: 8, shot: 15 },
      { made: 7, shot: 22 },
      { made: 2, shot: 6 },
      { made: 9, shot: 40 },
      { made: 14, shot: 24 },
      { made: 9, shot: 30},
      { made: 4, shot: 10 },
      { made: 5, shot: 9 },
    ]
  },
  {
    name: "charisma",
    nameslug: "charisma-osborne",
    pct: [28.3,	37.5,	40.0,	30.0,	30.8,	71.4,	39.7,	25.9,	75.0],
    totals: [
      { made: 15, shot: 53 },
      { made: 3, shot: 8 },
      { made: 6, shot: 15 },
      { made: 3, shot: 10 },
      { made: 9, shot: 33 },
      { made: 30, shot: 42 },
      { made: 25, shot: 63 },
      { made: 7, shot: 27 },
      { made: 6, shot: 8 }
    ]
  },
  {
    name: "dominique",
    nameslug: "dominique-onu",
    pct: [36.4,	62.5,	20.0,	0,	26.7,	57.1,	41.7,	46.2,	33.3],
    totals: [
      { made: 4, shot: 11 },
      { made: 5, shot: 8 },
      { made: 1, shot: 5 },
      { made: 0, shot: 0 },
      { made: 8, shot: 30 },
      { made: 16, shot: 28 },
      { made: 5, shot: 12 },
      { made: 6, shot: 13 },
      { made: 1, shot: 3 }
    ]
  },
  {
    name: "jaelynn",
    nameslug: "jaelynn-penn",
    pct: [20.8,	57.1,	29.2,	29.4,	46.2,	61.9,	20.0,	34.8,	0.0],
    totals: [
      { made: 5, shot: 24 },
      { made: 4, shot: 7 },
      { made: 7, shot: 24 },
      { made: 5, shot: 17 },
      { made: 12, shot: 26 },
      { made: 13, shot: 21 },
      { made: 6, shot: 30 },
      { made: 8, shot: 23 },
      { made: 0, shot: 4 }
    ]
  },
  {
    name: "iimari",
    nameslug: "iimari-thomas",
    pct: [41.7,	50.0,	50.0,	0.0,	35.7,	70.2,	46.2,	41.7,	16.7],
    totals: [
      { made: 10, shot: 24 },
      { made: 1, shot: 2},
      { made: 4, shot: 8 },
      { made: 0, shot: 1 },
      { made: 20, shot: 56 },
      { made: 92, shot: 131 },
      { made: 6, shot: 13 },
      { made: 5, shot: 12 },
      { made: 1, shot: 6 }
    ]
  },
  {
    name: "tyger",
    nameslug: "tyger-campbell",
    pct: [51.4,	50.0,	39.4,	42.9,	32.3,	56.3,	28.6,	36.8,	0.0],
    totals: [
      { made: 19, shot: 37 },
      { made: 4, shot: 8 },
      { made: 13, shot: 33 },
      { made: 6, shot: 14 },
      { made: 10, shot: 31 },
      { made: 18, shot: 32 },
      { made: 8, shot: 28 },
      { made: 7, shot: 19 },
      { made: 0, shot: 4},
    ]
  },
  {
    name: "johnny",
    nameslug: "johnny-juzang",
    pct: [33.3,	33.3,	29.3,	51.7,	42.9,	69.0,	47.1,	35.6,	40.0,],
    totals: [
      { made: 13, shot: 39 },
      { made: 3, shot: 9 },
      { made: 12, shot: 41 },
      { made: 15, shot: 29 },
      { made: 24, shot: 56 },
      { made: 29, shot: 42 },
      { made: 16, shot: 34 },
      { made: 16, shot: 45 },
      { made: 2, shot: 5 }
    ]
  },
  {
    name: "jules",
    nameslug: "jules-bernard",
    pct: [30.2,	25.0,	20.0,	75.0,	41.4,	59.0,	26.5,	38.1,	66.7],
    totals: [
      { made: 16, shot: 53 },
      { made: 2, shot: 8 },
      { made: 4, shot: 20 },
      { made: 6, shot: 8 },
      { made: 12, shot: 29 },
      { made: 23, shot: 39 },
      { made: 9, shot: 34 },
      { made: 8, shot: 21 },
      { made: 2, shot: 3 }
    ]
  },
  {
    name: "jaime",
    nameslug: "jaime-jaquez",
    pct: [32.0,	27.3,	55.6,	33.3,	42.0,	64.9,	21.4, 33.3,	0.0],
    totals: [
      { made: 8, shot: 25 },
      { made: 3, shot: 11 },
      { made: 15, shot: 27 },
      { made: 2, shot: 6 },
      { made: 29, shot: 69 },
      { made: 48, shot: 74 },
      { made: 3, shot: 14 },
      { made: 3, shot: 9 },
      { made: 0, shot: 3 }
    ]
  },
  {
    name: "cody",
    nameslug: "cody-riley",
    pct: [50.0, 0,	46.2,	53.8,	34.8,	50.0,	50.0,	53.3,	0],
    totals: [
      { made: 1, shot: 2 },
      { made: 0, shot: 0 },
      { made: 6, shot: 13 },
      { made: 7, shot: 13 },
      { made: 8, shot: 23 },
      { made: 15, shot: 30 },
      { made: 1, shot: 2 },
      { made: 8, shot: 15 },
      { made: 0, shot: 0 }
    ]
  }
];

const playersM = [
  {
    name: "tyger",
    nameslug: "tyger-campbell",
    pct: [51.4,	50.0,	39.4,	42.9,	32.3,	56.3,	28.6,	36.8,	0.0],
    totals: [
      { made: 19, shot: 37 },
      { made: 4, shot: 8 },
      { made: 13, shot: 33 },
      { made: 6, shot: 14 },
      { made: 10, shot: 31 },
      { made: 18, shot: 32 },
      { made: 8, shot: 28 },
      { made: 7, shot: 19 },
      { made: 0, shot: 4},
    ]
  },
  {
    name: "johnny",
    nameslug: "johnny-juzang",
    pct: [33.3,	33.3,	29.3,	51.7,	42.9,	69.0,	47.1,	35.6,	40.0,],
    totals: [
      { made: 13, shot: 39 },
      { made: 3, shot: 9 },
      { made: 12, shot: 41 },
      { made: 15, shot: 29 },
      { made: 24, shot: 56 },
      { made: 29, shot: 42 },
      { made: 16, shot: 34 },
      { made: 16, shot: 45 },
      { made: 2, shot: 5 }
    ]
  },
  {
    name: "jules",
    nameslug: "jules-bernard",
    pct: [30.2,	25.0,	20.0,	75.0,	41.4,	59.0,	26.5,	38.1,	66.7],
    totals: [
      { made: 16, shot: 53 },
      { made: 2, shot: 8 },
      { made: 4, shot: 20 },
      { made: 6, shot: 8 },
      { made: 12, shot: 29 },
      { made: 23, shot: 39 },
      { made: 9, shot: 34 },
      { made: 8, shot: 21 },
      { made: 2, shot: 3 }
    ]
  },
  {
    name: "jaime",
    nameslug: "jaime-jaquez",
    pct: [32.0,	27.3,	55.6,	33.3,	42.0,	64.9,	21.4, 33.3,	0.0],
    totals: [
      { made: 8, shot: 25 },
      { made: 3, shot: 11 },
      { made: 15, shot: 27 },
      { made: 2, shot: 6 },
      { made: 29, shot: 69 },
      { made: 48, shot: 74 },
      { made: 3, shot: 14 },
      { made: 3, shot: 9 },
      { made: 0, shot: 3 }
    ]
  },
  {
    name: "cody",
    nameslug: "cody-riley",
    pct: [50.0, 0,	46.2,	53.8,	34.8,	50.0,	50.0,	53.3,	0],
    totals: [
      { made: 1, shot: 2 },
      { made: 0, shot: 0 },
      { made: 6, shot: 13 },
      { made: 7, shot: 13 },
      { made: 8, shot: 23 },
      { made: 15, shot: 30 },
      { made: 1, shot: 2 },
      { made: 8, shot: 15 },
      { made: 0, shot: 0 }
    ]
  }
];

const PlayerImage = styled("img")`
  width: 100%;
  height: 70%;
  object-fit: contain;
`;

const PlayerName = styled("div") `
  padding-top: 20%;
  padding-left: 5%;
  font-family: Optima;
  font-style: normal;
  font-weight: bold;
  font-family: Optima;
    font-size: 18px;
    line-height: 19px;
    text-transform: uppercase;

color: #FFFFFF;
`
const About = styled("div") ` 
  font-family: Optima;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: white;
  padding-left: 30%;
  padding-right: 30%;
  padding-top: 6%;
`

const AboutText = styled("div") `
  font-family: Optima;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  color: white;
  padding-left: 30%;
  padding-right: 30%;
  span {
    text-transform: uppercase;
    background-color: ${colors.background};
    padding-top: 0%;
    bottom: 80px;
    width: 100%;
    font-size: 9px;
    padding-left: 0%;
    padding-right: 0%;
    display: block;
    align-items: left;
    align: left:
    width: 100vw;
  }
`
const Credits = styled("div") ` 
    text-transform: uppercase;
    background-color: ${colors.background};
    padding-top: 0%;
    font-size: 9px;
    padding-left: 60%;
    right: 0px;
    display: block;
    align-items: right;
    align: right:
    width: 100vw;
    color: white;
    font-family: Optima;
`
const PlayerDetails = styled("div") `
  padding-left: 5%;
  font-family: Optima;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
line-height: 17px;
/* identical to box height */

display: flex;
align-items: center;
color: #FFFFFF;
`

// {
//   name: "michaela",
//   nameslug: "michaela-onyenwere",
//   pct: [1, 1, 1, 1, 1, 1, 1, 1, 1]
// },
// {
//   name: "lauryn",
//   nameslug: "lauryn-miller",
//   pct: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 1, 1, 1]
// },
// {
//   name: "charisma",
//   nameslug: "charisma-osborne",
//   pct: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 1, 1, 1]
// },
// {
//   name: "japreece",
//   nameslug: "japreece-dean",
//   pct: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 1, 1, 1]
// }

const name_to_img = name => {
  if (name == "charisma-osborne") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/wbb-20EM-9ebeedb54083acbfb6eb7c57643667a8.png"></PlayerImage><Credits>(<b>Esther Ma</b>/Daily Bruin staff)</Credits></>;
  if (name == "dominique-onu") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/wbb-2LMan-2f0f5e1dae1afceca343c38619b7b32a.png" /> <Credits>(<b>Lauren Man</b>/Daily Bruin senior staff)</Credits></>;
  if (name == "jaelynn-penn") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/wbb-31SJ-3b6ed9cac3d6b5a5d3bc398bd6129168.png" /> <Credits>(<b>Sakshi Joglekar</b>/Assistant Photo editor)</Credits></>;
  if (name == "natalie-chou") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/wbb-23MG-1428b7fecff2e954bd48347743607a47.png" /><Credits>(<b>Marie Goldfarb</b>/Daily Bruin)</Credits></>;
  if (name == "iimari-thomas") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/wbb-24CK-44b944d079ad84504883711e4a7da25e.png" /><Credits>(<b>Christine Kao</b>/Daily Bruin staff)</Credits></>;
  if (name == "tyger-campbell") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/mbb-10JC-db3b824408c3e80cc218560f53dc8974.png" /><Credits>(<b>Jeremy Chen</b>/Daily Bruin staff)</Credits></>;
  if (name == "johnny-juzang") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/mbb-3ACB-1970f388b1a8e4c62978273827e8d4cb.png" /><Credits>(<b>Anika Chakrabarti</b>/Assistant Photo editor)</Credits></>;
  if (name == "jules-bernard") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/mbb-1ACB-d327f870ebebfd42424b0ac3818409bf.png" /><Credits>(<b>Anika Chakrabarti</b>/Assistant Photo editor)</Credits></>;
  if (name == "jaime-jaquez") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/mbb-24SJ-b05f2ab195bfd185d04097f2f8bd5542.png" /><Credits>(<b>Sakshi Joglekar</b>/Assistant Photo editor)</Credits></>;
  if (name == "cody-riley") return <><PlayerImage src="https://assets.dailybruin.com/images/interactive.2022.basketball/mbb-2ALK-aab6fb0be0c31b78fd9d3f568b2e6b1c.png" /><Credits>(<b>Ashley Kenney</b>/Photo editor)</Credits></>;
  else return <PlayerImage src={natalie_img} />;
};

const name_to_name = name => {
    if (name == "natalie-chou") return <>
    <PlayerName>NATALIE CHOU</PlayerName>
    <PlayerDetails>#23</PlayerDetails>
    <PlayerDetails>Guard</PlayerDetails>
    <PlayerDetails>Graduate Student</PlayerDetails>
    </>;
  if (name == "charisma-osborne") return <>
  <PlayerName>CHARISMA OSBORNE</PlayerName>
  <PlayerDetails>#20</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Junior</PlayerDetails>
  </>;
  if (name == "dominique-onu") return <>
  <PlayerName>DOMINIQUE ONU</PlayerName>
  <PlayerDetails>#2</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Redshirt Freshman</PlayerDetails>
  </>;
  if (name == "jaelynn-penn") return <>
  <PlayerName>JAELYNN PENN</PlayerName>
  <PlayerDetails>#31</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Graduate Student</PlayerDetails>
  </>;
  if (name == "iimari-thomas") return <>
  <PlayerName>IIMAR'I THOMAS</PlayerName>
  <PlayerDetails>#24</PlayerDetails>
  <PlayerDetails>Forward</PlayerDetails>
  <PlayerDetails>Graduate Student</PlayerDetails>
  </>;
  if (name == "jaime-jaquez") return <>
  <PlayerName>JAIME JAQUEZ JR.</PlayerName>
  <PlayerDetails>#24</PlayerDetails>
  <PlayerDetails>Guard/Forward</PlayerDetails>
  <PlayerDetails>Junior</PlayerDetails>
  </>;
  if (name == "tyger-campbell") return <>
  <PlayerName>TYGER CAMPBELL</PlayerName>
  <PlayerDetails>#10</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Redshirt Junior</PlayerDetails>
  </>;
  if (name == "johnny-juzang") return <>
  <PlayerName>JOHNNY JUZANG</PlayerName>
  </>;
  if (name == "jules-bernard") return <>
  <PlayerName>JULES BERNARD</PlayerName>
  </>;
  if (name == "cody-riley") return <>
  <PlayerName>CODY RILEY</PlayerName>
  </>;
      
  else return <>
  <PlayerName>NATALIE CHOU</PlayerName>
  </>;
}

const name_to_graphic = name => {
  if (name == "natalie-chou") return <>
    <PlayerName>NATALIE CHOU</PlayerName>
    <PlayerDetails>#23</PlayerDetails>
    <PlayerDetails>Guard</PlayerDetails>
    <PlayerDetails>Graduate Student</PlayerDetails>
    </>;
  if (name == "charisma-osborne") return <>
  <PlayerName>CHARISMA OSBORNE</PlayerName>
  <PlayerDetails>#20</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Junior</PlayerDetails>
  </>;
  if (name == "dominique-onu") return <>
  <PlayerName>DOMINIQUE ONU</PlayerName>
  <PlayerDetails>#2</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Redshirt Freshman</PlayerDetails>
  </>;
  if (name == "jaelynn-penn") return <>
  <PlayerName>JAELYNN PENN</PlayerName>
  <PlayerDetails>#31</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Graduate Student</PlayerDetails>
  </>;
  if (name == "iimari-thomas") return <>
  <PlayerName>IIMAR'I THOMAS</PlayerName>
  <PlayerDetails>#24</PlayerDetails>
  <PlayerDetails>Forward</PlayerDetails>
  <PlayerDetails>Graduate Student</PlayerDetails>
  </>;
  if (name == "jaime-jaquez") return <>
  <PlayerName>JAIME JAQUEZ JR.</PlayerName>
  <PlayerDetails>#24</PlayerDetails>
  <PlayerDetails>Guard/Forward</PlayerDetails>
  <PlayerDetails>Junior</PlayerDetails>
  </>;
  if (name == "tyger-campbell") return <>
  <PlayerName>TYGER CAMPBELL</PlayerName>
  <PlayerDetails>#10</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Redshirt Junior</PlayerDetails>
  </>;
  if (name == "johnny-juzang") return <>
  <PlayerName>JOHNNY JUZANG</PlayerName>
  <PlayerDetails>#3</PlayerDetails>
  <PlayerDetails>Guard</PlayerDetails>
  <PlayerDetails>Junior</PlayerDetails>
  </>;
  if (name == "jules-bernard") return <>
  <PlayerName>JULES BERNARD</PlayerName>
  <PlayerDetails>#1</PlayerDetails>
  <PlayerDetails>Guard/Forward</PlayerDetails>
  <PlayerDetails>Junior</PlayerDetails>
  </>;
  if (name == "cody-riley") return <>
  <PlayerName>CODY RILEY</PlayerName>
  <PlayerDetails>#2</PlayerDetails>
  <PlayerDetails>Forward</PlayerDetails>
  <PlayerDetails>Redshirt Senior</PlayerDetails>
  </>;
      
  else return <>
  <PlayerName>NATALIE CHOU</PlayerName>
  <PlayerDetails>#23</PlayerDetails>
  <PlayerDetails>Position</PlayerDetails>
  <PlayerDetails>Grad Student</PlayerDetails>
  </>;
};

const name_for_hover = name => {
  if (name == "natalie-chou") 
    return <PlayerName>NATALIE CHOU</PlayerName>;
  if (name == "dominique-onu") 
    return <PlayerName>DOMINIQUE ONU</PlayerName>;
  if (name == "jaelynn-penn") 
    return <PlayerName>JAELYNN PENN</PlayerName>;
  if (name == "charisma-osborne")
    return <PlayerName>CHARISMA OSBORNE</PlayerName>;
  if (name == "iimari-thomas") 
    return <PlayerName>IIMAR'I THOMAS</PlayerName>;
  if (name == "cody-riley") {console.log("cody!");
    return <PlayerName>CODY RILEY</PlayerName>;}
  if (name == "tyger-campbell") 
    return <PlayerName>TYGER CAMPBELL</PlayerName>;
  if (name == "jaime-jaquez") 
    return <PlayerName>JAIME JAQUEZ</PlayerName>;
  if (name == "jules-bernard") 
    return <PlayerName>JULES BERNARD</PlayerName>;
  if (name == "johnny-juzang") 
    return <PlayerName>JOHNNY JUZANG</PlayerName>;
  
  else return <div>haha</div>;
};

const PlayersElem = styled.div`
  overflow: auto;
  
  .section {
    height: 100vh;
    width: 100vw;
    background-color: ${colors.background};
  }
  .face {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    
  }
  .face_front {
    background-color: ${colors.background};
    
    
  }
  .face_back {
    background-color: ${colors.background};
    
    padding: 20px;
    box-sizing: border-box;
  }
  .stagger {
    width: 50px;
    height: 50px;
    left: 700px;
    background-color: ${colors.background};
    position: relative;
  }
  .sticky,
  .sticky2 {
    height: 100vh;
    width: 50%;
    & .animation,
    .animation2 {
      width: 100%;
      height: 100%;
      right: 0;
      position: absolute;
      & svg {
        opacity: 1;
        position: absolute;
        width: 300px;
        height: 300px;
      }
    }
    .heading {
      position: absolute;
      height: 100%;
      width: 100%;
      h2 {
        font-size: 40px;
        position: absolute;
        bottom: 10%;
        left: 10%;
        margin: 0;
      }
    }
  }
`;

const PlayerCard = styled.div ` 
background-color: ${colors.background};
overflow: hidden;
height: 100vh;
width: 100vw;
text-align: left;
position: relative;
`
const HoverCard = styled.div ` 
background-color: ${colors.background};
overflow: hidden;
height: 75vh;
width: 100vw;
text-align: left;
position: relative;
`



export default class MobilePlayers extends React.Component  {
  constructor(props) {
    super(props);
    //this.refmarker = React.createRef();
    this.state = {
      windowHeight: 0,
      windowWidth: 0,
      hoverIndex: 0,
      color: "white",
      displayHover: new Array(10).fill(false)
    };
    this.updateHover = this.updateHover.bind(this);
    this.showHover = this.showHover.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  updateWindowDimensions() {
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    });
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateHover(newIndex, alpha, shots, index){
    this.setState({hoverIndex: newIndex-1});
    if (index !== undefined){
      let hoverArray = new Array(10).fill(false);
      hoverArray[index] = true;
      this.setState({displayHover: hoverArray});
      if (shots < 5){
        this.setState({color:`rgba(128, 128, 128,.3)`})
      }else{
      this.setState({color:`rgba(8, 98, 158,${alpha})`})
      }
    }
  }

  showHover(){
    return null
  }

  render() {
      var Players;
      Players = playersW;
      Players = Players.map((player, index) => {
      const { name, nameslug } = player;
      const { pct, totals } = player;
      if (player.nameslug == 'tyger-campbell') {
        return (
            <>
            <Section id="men">MEN'S BASKETBALL</Section>
            <PlayerCard> 
                {name_to_graphic(nameslug)}
                {name_to_img(nameslug)}
            </PlayerCard>
            <ShotChart player={player} updateHover = {this.updateHover} showHover = {this.showHover} index = {index}/>
            {(this.state.displayHover[index]) ?
            <HoverCard >       
            <div
              className={css`
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background-color: ${colors.background};
              `}
            >
              {/* {console.log('mobile media', this.state.displayHover)} */}
               
              <div>
              {name_for_hover(nameslug)}
              <PopUp
                pct={pct[this.state.hoverIndex]}
                totals={totals[this.state.hoverIndex]}
                color = {this.state.color}
                key={`popup_${nameslug}_${this.state.hoverIndex}`}
                
              />
              <About>About the data</About><AboutText>{this.props.about}</AboutText></div> 
              </div>
            </HoverCard>   : null}   
        </>
        )
      }
      return (
          <>
        <PlayerCard> 
                {name_to_graphic(nameslug)}
                {name_to_img(nameslug)}
            </PlayerCard>
            <ShotChart player={player} updateHover = {this.updateHover} showHover = {this.showHover} index = {index}/>
            {(this.state.displayHover[index]) ? 
            <HoverCard> 
            {name_to_name(nameslug)}      

            <div
              className={css`
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background-color: ${colors.background};
              `}
            >
              {/* {console.log(this.state.displayHover)} */}
              <div>
              {name_for_hover(nameslug)}
              <PopUp
                pct={pct[this.state.hoverIndex]}
                totals={totals[this.state.hoverIndex]}
                color = {this.state.color}
                key={`popup_${nameslug}_${this.state.hoverIndex}`}
                
              />
              {/* {name_to_name(nameslug)} */}
              <About>About the data</About><AboutText>{this.props.about}</AboutText></div> 
              </div>
            </HoverCard> : <></> }
        </>   
      );
    });

    return (
      <PlayersElem>
        {}
        <Controller>{Players}</Controller>
      </PlayersElem>
    );
  }
}